import React from 'react';
import { Users, UserPlus, CheckCircle, XCircle, Trophy } from 'lucide-react';

export const D2DStatsCards = ({ d2dStats }) => {
  if (!d2dStats) return null;

  return (
    <div className="space-y-6">
      {/* Main Stats */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <div className="bg-white p-6 rounded-lg border border-zinc-200">
          <div className="flex items-center gap-2 mb-2">
            <Users className="h-5 w-5 text-zinc-600" />
            <p className="text-sm text-zinc-600">Ümumi Qeydlər</p>
          </div>
          <p className="text-3xl font-bold text-zinc-900">{d2dStats.total || 0}</p>
        </div>
        <div className="bg-blue-50 p-6 rounded-lg border border-blue-200">
          <div className="flex items-center gap-2 mb-2">
            <UserPlus className="h-5 w-5 text-blue-600" />
            <p className="text-sm text-blue-800">Yeni</p>
          </div>
          <p className="text-3xl font-bold text-blue-900">{d2dStats.new || 0}</p>
        </div>
        <div className="bg-green-50 p-6 rounded-lg border border-green-200">
          <div className="flex items-center gap-2 mb-2">
            <CheckCircle className="h-5 w-5 text-green-600" />
            <p className="text-sm text-green-800">Konversiya</p>
          </div>
          <p className="text-3xl font-bold text-green-900">{d2dStats.converted || 0}</p>
        </div>
        <div className="bg-purple-50 p-6 rounded-lg border border-purple-200">
          <div className="flex items-center gap-2 mb-2">
            <span className="text-purple-600 font-bold">%</span>
            <p className="text-sm text-purple-800">Konversiya Faizi</p>
          </div>
          <p className="text-3xl font-bold text-purple-900">
            {d2dStats.conversion_rate !== undefined ? d2dStats.conversion_rate : 
              (d2dStats.total - (d2dStats.cancelled || 0) > 0 
                ? ((d2dStats.converted / (d2dStats.total - (d2dStats.cancelled || 0))) * 100).toFixed(1) 
                : 0)}%
          </p>
        </div>
      </div>

      {/* Cancelled count */}
      {d2dStats.cancelled > 0 && (
        <div className="bg-red-50 p-4 rounded-lg border border-red-200 inline-flex items-center gap-2">
          <XCircle className="h-5 w-5 text-red-600" />
          <span className="text-red-800">Ləğv edilmiş: <strong>{d2dStats.cancelled}</strong></span>
        </div>
      )}
    </div>
  );
};

export const D2DTopAgents = ({ d2dStats }) => {
  if (!d2dStats?.top_agents || d2dStats.top_agents.length === 0) return null;

  return (
    <div className="bg-white rounded-lg border border-zinc-200 overflow-hidden mt-6">
      <div className="bg-orange-600 p-4">
        <h2 className="text-xl font-bold uppercase tracking-tight text-white flex items-center gap-2">
          <Trophy className="h-5 w-5" />
          Top D2D Agentlər
        </h2>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-zinc-100 border-b border-zinc-200">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-bold text-zinc-700 uppercase">Sıra</th>
              <th className="px-6 py-3 text-left text-xs font-bold text-zinc-700 uppercase">Agent</th>
              <th className="px-6 py-3 text-center text-xs font-bold text-zinc-700 uppercase">Qeydlər</th>
              <th className="px-6 py-3 text-center text-xs font-bold text-zinc-700 uppercase">Konversiya</th>
              <th className="px-6 py-3 text-center text-xs font-bold text-zinc-700 uppercase">Faiz</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-zinc-200">
            {d2dStats.top_agents.map((agent, index) => (
              <tr key={agent.agent_id} className={index < 3 ? 'bg-orange-50' : ''}>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="flex items-center">
                    {index === 0 && <Trophy className="h-5 w-5 text-yellow-500 mr-2" />}
                    {index === 1 && <Trophy className="h-5 w-5 text-zinc-400 mr-2" />}
                    {index === 2 && <Trophy className="h-5 w-5 text-amber-600 mr-2" />}
                    <span className="font-bold text-zinc-900">{index + 1}</span>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <span className="font-semibold text-zinc-900">{agent.agent_name}</span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-center">
                  <span className="font-bold text-zinc-900">{agent.total_records}</span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-center">
                  <span className="font-bold text-green-600">{agent.converted}</span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-center">
                  <span className="font-bold text-purple-600">
                    {agent.conversion_rate !== undefined ? agent.conversion_rate : 
                      (agent.total_records > 0 ? ((agent.converted / agent.total_records) * 100).toFixed(1) : 0)}%
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default D2DStatsCards;
